import { Injectable } from '@angular/core';
import { IDBPDatabase, openDB } from 'idb';

@Injectable({
  providedIn: 'root'
})
export class IdbService {
  constructor() {}

  public async get(key: string): Promise<any> {
    return (await this.connect()).get('a-vtc-db', key);
  }
  public async set(key: string, val: any): Promise<void> {
    (await this.connect()).put('a-vtc-db', val, key);
  }
  public async delete(key: string): Promise<any> {
    return (await this.connect()).delete('a-vtc-db', key);
  }
  public async clear(): Promise<any> {
    return (await this.connect()).clear('a-vtc-db');
  }
  public async keys(): Promise<any> {
    return (await this.connect()).getAllKeys('a-vtc-db');
  }
  private async connect(): Promise<IDBPDatabase> {
    return await openDB('a-vtc', 1, {
      upgrade: (db) => {
        db.createObjectStore('a-vtc-db');
      }
    });
  }
}
